import type { EdgeToEdgePlugin } from 'capacitor7-android-edge-to-edge-support';

type EdgeToEdgeModuleCompat = typeof import('capacitor7-android-edge-to-edge-support');

export * from 'capacitor7-android-edge-to-edge-support';

// We are intentionally using a mutable export so that we can mimic the original import
// syntax for Capacitor plugins, while still dynamically loading the correct capacitor version.
// skipcq: JS-E1009
export let EdgeToEdge: EdgeToEdgePlugin;

const load = (module: EdgeToEdgeModuleCompat) => {
  EdgeToEdge = module.EdgeToEdge;
};

export default load;
